import React, {useCallback, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {Button, Container, Paper, TableBody, TableCell, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import TamponiCard from "./tamponi/TamponiCard";
import HideAppBar from "../../widgets/header/HideAppBar";
import axios from "axios";
import {BASE_NAME} from "../../../services/utils/ApiUrls";
import {getConfig} from "../../../services/utils/ConfigUtils";
import CustomSortTable from "../../widgets/tables/CustomSortTable";
import CustomHead from "../../widgets/tables/head/CustomHead";
import {uploadHead} from "../../widgets/tables/head/Heads";
import {TABLE_INITIAL_STATE, TableReducer} from "../../../reducers/TableReducer";
import {getComparator, handleRequestSort, stableSort} from "../../../utils/TableUtils";
import {setOrder, setOrderBy, setPage} from "../../../services/TableServices";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import {formatText} from "../../widgets/chat/ChatFab";
import GuaritiCard from "./tamponi/GuaritiCard";

const initTableState = () => {
	return {
		page: 0,
		order: "desc",
		orderBy: "id",
		rowsPerPage: 20,
		count: 0,
	}
}

const GestioneUpload = () => {
	const classes = BaseStyle();
	const [table, dispatchTable] = useReducer(TableReducer, TABLE_INITIAL_STATE, initTableState);
	const [jobs, setJobs] = useState([]);
	const [refresh, setRefresh] = useState(0);
	const [loading, setLoading] = useState(false);
	
	const onRequestSort = useCallback((event, property) => {
		handleRequestSort(event, property, table.order, table.orderBy, setOrder, setOrderBy, dispatchTable)
	}, [table.order, table.orderBy])
	
	useEffect(() => {
		document.body.style = `background: none;`;
	}, []);
	
	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "jobs/getAllJobs", getConfig())
			.then((response) => {
				setLoading(false);
				setJobs(response.data);
			})
	}, [refresh])
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Carico dati"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<TamponiCard/>
						</Grid>
						<Grid item xs={12}>
							<GuaritiCard/>
						</Grid>
						<Grid item xs={12}>
							<Paper className={classes.roundPaper}>
								<div style={{padding: 20}}>
									<Typography>
										Aggiorna la tabella per verificare lo stato del caricamento e la percentuale. In caso di errori in
										fase di caricamento o anomalie contatta gli sviluppatori.
									</Typography>
									<Button style={{borderRadius: 22, margin: 20}} onClick={() => setRefresh(prevState => ++prevState)}>
										Refresh tabella
									</Button>
								</div>
								<CustomSortTable
									head={
										<CustomHead
											rows={uploadHead}
											onRequestSort={onRequestSort}
											order={table.order}
											orderBy={table.orderBy}
										/>
									}
									body={
										<TableBody>
											{stableSort(jobs, getComparator(table.order, table.orderBy))
												.slice(table.page * table.rowsPerPage, table.page * table.rowsPerPage + table.rowsPerPage)
												.map((row, index) => {
													return (
														<TableRow key={index} hover>
															<TableCell>
																<Typography variant={"caption"}>{row.id}</Typography>
															</TableCell>
															<TableCell>
																<Typography variant={"caption"}>{row.fileName}</Typography>
															</TableCell>
															<TableCell>
																<Typography variant={"caption"}>{formatText(row.details)}</Typography>
															</TableCell>
															<TableCell>
																<Typography variant={"caption"}>{row.operator}</Typography>
															</TableCell>
															<TableCell>
																<Typography variant={"caption"}>{row.percentage}</Typography>
															</TableCell>
															<TableCell>
																<Typography
																	variant={"caption"}>{moment(new Date(row.scheduledAt)).format("HH:mm - DD/MM/YY")}</Typography>
															</TableCell>
															<TableCell>
																<Typography
																	variant={"caption"}>{row.finishedAt ? moment(new Date(row.finishedAt)).format("HH:mm - DD/MM/YY") : "--"}</Typography>
															</TableCell>
															<TableCell>
																<Typography variant={"caption"}>{row.status}</Typography>
															</TableCell>
														</TableRow>
													)
												})}
										</TableBody>
									}
									loading={loading}
									error={false}
									rowsPerPage={table.rowsPerPage}
									columCounter={uploadHead.length}
								/>
								<div style={{padding: 20, width: "100%"}}>
									<Button
										onClick={() => table.page === 0 ? setPage(0, dispatchTable) : setPage(table.page - 1, dispatchTable)}>
										Indietro
									</Button>
									<Button
										onClick={() => setPage(table.page + 1, dispatchTable)}>
										Avanti
									</Button>
								</div>
							</Paper>
						</Grid>
					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
}

export default React.memo(GestioneUpload)
